import React from 'react';
import { motion } from 'framer-motion';
export function CategoriesSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="categorias" className="py-14 md:py-16 bg-[#111827]" data-id="element-41">
      <div className="max-w-[980px] mx-auto px-4 text-center" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[24px] md:text-[32px] font-black mb-10 uppercase text-white tracking-wide" data-id="element-43">
          EXPLORÁ LAS CATEGORÍAS MÁS VENDIBLES
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="cursor-pointer relative group inline-block w-full" onClick={scrollToPricing} data-id="element-44">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e1a] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 flex items-end justify-center pb-8" data-id="element-45">
            <span className="btn-primary pointer-events-none !text-sm !py-3" data-id="element-46">
              VER TODO EL CATÁLOGO
            </span>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/bmGN6hbVxrEe2dV6ZHTZMg/kitspremiumonline.png" alt="Categorías del Kit Viral" className="w-full h-auto rounded-xl shadow-xl border border-white/10 group-hover:border-[#f5a623]/50 transition-colors duration-300" data-id="element-47" />
        </motion.div>
      </div>
    </section>;
}